import { render, staticRenderFns } from "./phone3.vue?vue&type=template&id=1f69cd42&scoped=true&"
var script = {}
import style0 from "./phone3.vue?vue&type=style&index=0&id=1f69cd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f69cd42",
  null
  
)

export default component.exports